export default "__VITE_ASSET__58dc065b__"